<template>
  <div class="p-5">
    <FormulateForm v-model="formFields" class="w-100">
      <pre><code>{{ formFields }}</code></pre>

      <FormulateInput
        name="fields"
        type="group"
        :repeatable="true"
        validation-name="Form fields"
        validation="min:1,length"
        add-label="++ Another Form field"
        #default="{ index }"
        element-class="w-100"
      >
        <FormulateInput
          name="field_type"
          label="Field type"
          label-class="mt-2"
          placeholder="Select an option"
          type="select"
          :options="fieldOptions"
        />
        <FormulateInput
          name="name"
          label="Field name"
          help="One word, no spaces"
          help-class="text-muted mb-2"
          validation="required"
        />
        <FormulateInput
          name="label"
          label="Label"
          help="Displayed field name"
          help-class="text-muted mb-2"
          validation="required"
        />
        <FormulateInput
          name="short_desc"
          label="Description"
          help="Short description about the field"
          help-class="text-muted mb-2"
          validation="required"
        />
        <div v-if="formFields.fields">
          <FormulateInput
            v-if="
              formFields.fields[index] &&
              ['select', 'checkbox', 'radio'].includes(
                formFields.fields[index].field_type
              )
            "
            name="options"
            type="group"
            :repeatable="true"
            validation-name="Form fields"
            validation="min:1,length"
            add-label="++ Another Form field"
            add-class="btn btn-info"
            #default="{ index }"
            element-class="w-100"
            style="background: #eee; border-radius: 5px"
            ><b-row>
              <FormulateInput
                name="value"
                label="Option value"
                help="One word, no spaces"
                validation="required"
              />
              <FormulateInput
                name="label"
                label="Option text"
                validation="required"
              />
            </b-row>
          </FormulateInput>
          <b-row
            v-if="
              formFields.fields[index] &&
              formFields.fields[index].field_type === 'range'
            "
          >
            <FormulateInput
              v-if="
                formFields.fields[index] &&
                formFields.fields[index].field_type === 'range'
              "
              name="minvalue"
              label="MIN value"
              help="MIN if range"
              help-class="text-muted mb-2"
            />

            <FormulateInput
              v-if="
                formFields.fields[index] &&
                formFields.fields[index].field_type === 'range'
              "
              name="maxvalue"
              label="MAX value"
              help="MAX if range"
            />
            <FormulateInput
              v-if="
                formFields.fields[index] &&
                formFields.fields[index].field_type === 'range'
              "
              name="step"
              label="STEP value"
              help="STEP if range"
            />
          </b-row>
        </div>
      </FormulateInput>
    </FormulateForm>
    <b-button variant="success" @click="submitForms"
      >Add fields to form</b-button
    >
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      formFields: {},
      loading: true,
      fieldOptions: [
        { value: "text", label: "Text field" },
        { value: "select", label: "Select from options" },
        { value: "checkbox", label: "Checkbox" },
        { value: "radio", label: "Radio buttons" },
        {
          value: "range",
          label: "Select value on a range slider",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentPackage: "api/getPackage",
    }),
  },
  methods: {
    submitForms: function () {
      this.isSending = true;

      return new Promise((resolve, reject) => {
        axios({
          url: `${this.$store.state.login.url}/api/dashboard/packages/${this.currentPackage.id}/form/add`,
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: this.formFields,
          method: "POST",
        })
          .then((response) => {
            this.isSending = false;
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            this.$router.go();

            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
  },
};
</script>
